// extracted by mini-css-extract-plugin
export var linkCtn = "direction-navigation-module--linkCtn--621zA";
export var linksWrapper = "direction-navigation-module--linksWrapper--kGuho";
export var navCtn = "direction-navigation-module--navCtn--6c0-I";